const team = {
	name: 'Employee | Contact Person',
	fields: {
		user: 'Employee',
		last_name: 'Name',
		active: 'Active',
		can_delete: 'Delete',
		can_update: 'Update',
		can_post: 'Create',
		can_settings: 'Settings',
		can_view_all_reports: 'View all reports',
	},
}

export default team
